import type { ReactNode } from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import { Form } from '@/components/Form'
import { Button } from '@/components/Button'
import {
  InfoGatheringDialogFieldGrid,
  InfoGatheringDialogScrollArea,
  InfoGatheringDialogSubsectionHeader,
} from '@/features/jobs/info-gathering/components/InfoGatheringDialog'

export interface EditBusinessProfileDialogProps {
  showing: boolean
  onRequestClose?: () => unknown
  onSubmit: () => unknown
  isSubmitPending: boolean
  businessFields: ReactNode
  contactFields: ReactNode
}

export function EditBusinessProfileDialog({
  showing,
  onRequestClose,
  onSubmit,
  isSubmitPending,
  businessFields,
  contactFields,
}: EditBusinessProfileDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={onRequestClose}
      disableCloseOnOutsideClick
      disableCloseOnEsc
    >
      <ModalSheetHeader withCloseButton bordered>
        <ModalSheetTitle emphasized>Fill in business info</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetSection spaced>
          <InfoGatheringDialogScrollArea>
            <Form>
              <InfoGatheringDialogSubsectionHeader>
                Business information
              </InfoGatheringDialogSubsectionHeader>
              <InfoGatheringDialogFieldGrid>
                {businessFields}
              </InfoGatheringDialogFieldGrid>

              <InfoGatheringDialogSubsectionHeader bordered>
                Contact information
              </InfoGatheringDialogSubsectionHeader>
              <InfoGatheringDialogFieldGrid>
                {contactFields}
              </InfoGatheringDialogFieldGrid>
            </Form>
          </InfoGatheringDialogScrollArea>
        </ModalSheetSection>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Save & Close"
            variant="primary"
            onPress={onSubmit}
            isPending={isSubmitPending}
            isDisabled={isSubmitPending}
            testId="edit-business-submit-button"
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
